/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Success_TitleInputs */



/**
* | output |
* | --- |
* | "Success" |
*
* @param {Iframe_Remote_Success_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_success_title = /** @type {((inputs?: Iframe_Remote_Success_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Success_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erfolg")
	if (locale === "it") return /** @type {LocalizedString} */ ("Successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Успех")
	if (locale === "es") return /** @type {LocalizedString} */ ("Éxito")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("成功")
	if (locale === "ja") return /** @type {LocalizedString} */ ("成功")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सफलता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sucesso")
	return /** @type {LocalizedString} */ ("Success")
});